import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const Loans = ({ size = 35, ...props }: { size?: number }) => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <G clipPath="url(#a)">
        <Mask
          id="b"
          width={24}
          height={24}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <Path
            fill="#fff"
            d="M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
          />
        </Mask>
        <G mask="url(#b)">
          <Path
            fill="#F2F7FF"
            d="M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
          />
          <Path
            fill="url(#c)"
            d="M20.094 12.814a.305.305 0 0 1-.213-.085c-.798-.792-2.472-.803-2.487-.803a.302.302 0 0 1-.212-.087.295.295 0 0 1 .212-.506c.078 0 1.935 0 2.913.975a.295.295 0 0 1-.213.506Z"
          />
          <Path
            fill="url(#d)"
            d="M9.896 12.814a.305.305 0 0 1-.214-.085.297.297 0 0 1-.065-.325.296.296 0 0 1 .065-.096c.979-.963 2.835-.975 2.913-.975.08 0 .156.031.213.087a.294.294 0 0 1 0 .419.302.302 0 0 1-.213.087c-.014 0-1.689 0-2.487.803a.301.301 0 0 1-.213.085Z"
          />
          <Path
            fill="url(#e)"
            d="M17.1 12.518h-1.5l-.6-4.74a5.616 5.616 0 0 1 3.6 0c-.6 2.074-.9 2.963-1.5 4.74Z"
          />
          <Path
            fill="url(#f)"
            d="M12.906 12.518h1.5l.6-4.74a5.616 5.616 0 0 0-3.6 0c.6 2.074.9 2.963 1.5 4.74Z"
          />
          <Path
            fill="url(#g)"
            d="M16.203 11.037h-2.4l-.6-4.74a5.616 5.616 0 0 1 3.6 0l-.6 4.74Z"
          />
          <Path
            fill="url(#h)"
            d="M21 18.888C21 22.148 18.3 22 15 22s-6 .149-6-3.11c0-3.26 2.7-7.852 6-7.852s6 4.592 6 7.851Z"
          />
          <Path
            fill="url(#i)"
            d="M17.4 10.977h-4.8c-.331 0-.6.266-.6.593 0 .327.269.593.6.593h4.8c.331 0 .6-.266.6-.593a.596.596 0 0 0-.6-.593Z"
          />
          <Mask
            id="j"
            width={6}
            height={6}
            x={12}
            y={14}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'luminance',
            }}
          >
            <Path fill="#fff" d="M17.734 14.295h-5.437v5.37h5.437v-5.37Z" />
          </Mask>
          <G mask="url(#j)">
            <Path
              fill="url(#k)"
              d="M17.734 16.98c0 1.483-1.217 2.685-2.718 2.685a2.727 2.727 0 0 1-2.346-1.326 2.648 2.648 0 0 1-.373-1.36c0-1.482 1.217-2.684 2.719-2.684a2.731 2.731 0 0 1 1.84.709c.54.49.878 1.194.878 1.976Z"
            />
            <Path
              fill="#fff"
              d="M16.131 16.342h-.37a.873.873 0 0 0-.096-.23h.466a.22.22 0 0 0 .222-.219.22.22 0 0 0-.222-.22h-2.097a.22.22 0 0 0-.222.22c0 .121.1.22.222.22h.857c.17 0 .318.092.396.229h-1.253a.22.22 0 0 0-.222.219c0 .12.1.219.222.219h1.253a.456.456 0 0 1-.396.23h-.857a.222.222 0 0 0-.203.132.217.217 0 0 0 .042.237l1.207 1.265a.223.223 0 0 0 .314.01.217.217 0 0 0 .009-.31l-.855-.896h.343a.898.898 0 0 0 .87-.668h.37a.22.22 0 0 0 .222-.22.22.22 0 0 0-.222-.218Z"
            />
          </G>
          <Path
            fill="url(#l)"
            d="m21.461 20.407-5.191 4.164a2.032 2.032 0 0 1-1.517.432l-6.996-.852-1.865.69c-1.001-1.03-.59-4.143-.59-4.143l.444-.322a1.684 1.684 0 0 1 .941-1.622l3-1.465 1.543-.754a1.466 1.466 0 0 1 1.397 2.575l-2.494 1.495 4.197.731a2.033 2.033 0 0 0 1.455-.297l4.174-2.71a1.284 1.284 0 0 1 1.502 2.078Z"
          />
          <Path
            fill="#3666B5"
            d="M3.47 20.326a1.466 1.466 0 0 0-.963 1.836l.804 2.573a1.466 1.466 0 1 0 2.799-.874l-.804-2.573a1.466 1.466 0 0 0-1.836-.962Z"
          />
          <Path
            fill="url(#m)"
            d="M7.227 16.777a4.868 4.868 0 1 0 0-9.736 4.868 4.868 0 0 0 0 9.736Z"
          />
          <Path
            fill="#F2F7FF"
            d="M7.221 17.318a5.373 5.373 0 0 1-3.824-1.585 5.373 5.373 0 0 1-1.584-3.824c0-1.445.562-2.803 1.584-3.825A5.374 5.374 0 0 1 7.22 6.5c1.445 0 2.803.563 3.825 1.584a5.374 5.374 0 0 1 1.584 3.825 5.373 5.373 0 0 1-1.584 3.824 5.373 5.373 0 0 1-3.825 1.585Zm0-10.186A4.746 4.746 0 0 0 3.843 8.53a4.746 4.746 0 0 0-1.399 3.378c0 1.276.497 2.476 1.4 3.378a4.746 4.746 0 0 0 3.377 1.4 4.746 4.746 0 0 0 3.379-1.4 4.746 4.746 0 0 0 1.399-3.378 4.746 4.746 0 0 0-1.4-3.378 4.746 4.746 0 0 0-3.378-1.4Z"
          />
          <Path
            fill="#fff"
            d="M6.153 14.792a.301.301 0 0 1-.278-.419L8.09 9.097a.302.302 0 0 1 .557.234l-2.214 5.276a.302.302 0 0 1-.279.185ZM5.733 11.544c-.706 0-1.28-.645-1.28-1.438 0-.794.574-1.439 1.28-1.439.706 0 1.28.645 1.28 1.439 0 .793-.574 1.438-1.28 1.438Zm0-2.273c-.373 0-.676.374-.676.835 0 .46.303.835.676.835.373 0 .677-.375.677-.835 0-.46-.304-.835-.677-.835ZM8.718 15.15c-.706 0-1.28-.645-1.28-1.438 0-.793.574-1.439 1.28-1.439.706 0 1.28.646 1.28 1.44 0 .793-.574 1.438-1.28 1.438Zm0-2.273c-.373 0-.677.375-.677.835 0 .46.304.835.677.835.373 0 .676-.374.676-.835 0-.46-.303-.835-.676-.835Z"
          />
        </G>
        <Rect
          width={32}
          height={32}
          fill="#D9D9D9"
          rx={2.65}
          style={{
            mixBlendMode: 'saturation',
          }}
        />
      </G>
      <Defs>
        <RadialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.83453 1.1904 -3.08927 -4.76088 19.593 11.768)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.83453 1.1904 -3.08927 -4.76088 12.093 11.768)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.21758 2.5348 -2.18388 -1.04901 18.179 8.443)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="f"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-.60291 2.44264 -2.11312 -.52158 13.97 8.535)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="g"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(115.657 6.001 8.633) scale(2.81207 2.42275)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="h"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(126.361 5.018 10.962) scale(9.5575 5.95305)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="i"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(164.057 7.478 6.82) scale(3.4671 5.20415)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="k"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-3.0212 4.3152 -11.52245 -8.0672 16.413 15.87)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="l"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-10.3044 7.59151 -8.1987 -11.12859 14.899 17.4)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="m"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(124.662 2.27 7.499) scale(9.51135 25.2872)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="a">
          <Rect width={24} height={24} fill="#fff" rx={2.65} />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
export default Loans
